export { default } from './EmprestimoGarantiaCarro';
